import { useQuery, useMutation, useQueryClient, useInfiniteQuery } from "@tanstack/react-query";

import { REVIEW_KEY } from "../constants/query.constants";
import { getProductReviews,postReview,updateReview } from "../repositories/reviews/reviewRepository";


export const useProductReviewsQuery = (productId) => {
  return useQuery({
    queryKey: [REVIEW_KEY, productId],
    queryFn: () => getProductReviews(productId),
    enabled: !!productId,
  });
};


export const usePostReviewMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: postReview,
    onSuccess: (data, variables) => {
      if (!variables?.product_id) return;
      queryClient.invalidateQueries({
        queryKey: [REVIEW_KEY, variables.product_id],
      });
    },
  });
};

export const useUpdateReviewMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateReview,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries([REVIEW_KEY]);
    },
  });
};
